import React from 'react';
import { CampaignType } from 'models/Campaign';
import useQueryParams from 'hooks/useQueryParams';
import classNames from 'classnames';

import './CampaignTabs.styles.scss';

const CampaignTabs = () => {
  const { params, setMultipleQueryParams, removeQueryParam } = useQueryParams();
  const activeTab = params?.campaignType || CampaignType.Scraping;

  const handleClick = (type: CampaignType) => {
    if (type !== CampaignType.Scraping) {
      setMultipleQueryParams({ campaignType: type }, true, true);
    } else {
      removeQueryParam('campaignType');
    }
    removeQueryParam('page');
  };

  return (
    <div className="filterTabs">
      <button
        onClick={() => handleClick(CampaignType.Scraping)}
        className={classNames('filterButton', {
          active: activeTab === CampaignType.Scraping,
        })}
      >
        Scraping Campaigns
      </button>
      <button
        onClick={() => handleClick(CampaignType.Personal)}
        className={classNames('filterButton', {
          active: activeTab === CampaignType.Personal,
        })}
      >
        Personal Campaigns
      </button>
    </div>
  );
};

export default CampaignTabs;
